export const updateMarginLeft = (width) => {
  const screenWidth = window.innerWidth;
  const calculatedMargin = (screenWidth - width) / 2;
  const marginInPercentage = (calculatedMargin / screenWidth) * 100;
  return marginInPercentage;
};
